import * as React from "react";
const InstallationInformationView = React.lazy(() => import("./InstallationInformationViewContainer"));

export { InstallationInformationView };
